export const setCookie = (key: string, value: string, options?: string) =>
  (document.cookie = `${key}=${value};${options}`);

export const getCookie = (key: string) =>
  document.cookie
    .split("; ")
    .find((cookie) => cookie.startsWith(`${key}=`))
    ?.substring(key.length + 1);

// docs/ADR/IS_AUTHENTICATING-cookie.md
const IS_AUTHENTICATING = "IS_AUTHENTICATING";

export const setIsAuthenticatingCookie = (value: boolean) =>
  (document.cookie = value ? `${IS_AUTHENTICATING}=true;path=/;max-age=60` : `${IS_AUTHENTICATING}=false;path=/`);

export const getIsAuthenticatingCookie = () => getCookie(IS_AUTHENTICATING);

export const setRefreshTokenCookie = (value: string) => {
  document.cookie = `${import.meta.env.VITE_REFRESH_TOKEN_COOKIE_KEY}=${value};max-age=2592000;path=/;domain=weforum.org;`;
};

export const getRefreshTokenCookie = () => getCookie(import.meta.env.VITE_REFRESH_TOKEN_COOKIE_KEY);

// 'Remove' cookies by expiring them
export const removeRefreshTokenCookie = () => {
  document.cookie = `${import.meta.env.VITE_REFRESH_TOKEN_COOKIE_KEY}=;max-age=0;path=/;domain=weforum.org;`;
};
